<template>
  <div>
    <div class="subnavbackground">
      <button
        id="tooltip-target-ssasinfo"
        class="this-tool-icon-container clientinfotv"
      >
        <img
          class="this-tool-icon d-block"
          src="../../../assets/images/tv-blue.svg"
          alt=""
        >
      </button>
      <b-tooltip
        v-if="SSASMessage != null || config_CurrentClientVersion != null"
        target="tooltip-target-ssasinfo"
        triggers="hover"
        custom-class="infoTooltip"
      >
        <p>Klient version: {{ config_CurrentClientVersion }}</p>
        <p>API version: {{ SSASMessage.version }}</p>
        <p>Modell: {{ SSASMessage.linkedSSAS }}</p>
        <p>Senaste AAM-import: {{ SSASMessage.lastImported }}</p>
        <p>Senaste SSAS processning: {{ SSASMessage.lastProcessed }}</p>
        <p>Sista paneldag: {{ SSASMessage.latestDay }}</p>
        <p>Första publiceringsdag: {{ SSASMessage.publishedFromDate }}</p>
        <p>Sista publiceringsdag: {{ SSASMessage.publishedToDate }}</p>
        <p>Första publiceringsdag ad: {{ SSASMessage.adPublishedFromDate }}</p>
      </b-tooltip>
      <div class="center">
        <router-link
          v-if="this.$store.state.systemInfo.lightAccess || this.$store.state.systemInfo.fullAccess"
          to="/toplist"
        >
          Topplista
        </router-link>
        <router-link
          v-if="this.$store.state.systemInfo.fullAccess"
          to="/programs"
        >
          Program
        </router-link>
        <router-link
          v-if="(config_ShowCampaignTab && this.$store.state.systemInfo.fullAccess) || (config_ShowCampaignTab && this.$store.state.systemInfo.advertiserAccess)"
          to="/campaigns"
        >
          Reklam
        </router-link>
        <router-link
          v-if="this.$store.state.systemInfo.fullAccess"
          to="/site"
        >
          Site
        </router-link>
      </div>
      <div
        v-if="anyFormFieldsLoaded"
        class="right"
      >
        <b-button
          id="infoButton"
          v-b-toggle.sidebar-1
          class="btn-xs mx-2"
          variant="primary"
        >
          <b-icon icon="info-circle" />
        </b-button>
        <b-tooltip
          target="infoButton"
          triggers="hover"
          placement="top"
        >
          Se informationslogg
        </b-tooltip>
        
        <b-button
          id="bookButton"
          class="btn-xs"
          variant="info"
          @click="openInfoLink"
        >
          <b-icon icon="book" />
          <span />
        </b-button>
        <b-tooltip
          target="bookButton"
          triggers="hover"
          placement="top"
        >
          Läs användarmanual
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubNav',
  computed: {
    SSASMessage() {
      return this.$store.state.systemInfo.ssasInfo
    },
    anyFormFieldsLoaded(){
      let anyFormFieldsLoaded = false
      if(this.$store.getters["systemInfo/getAnyFormFieldsLoaded"])
        anyFormFieldsLoaded = true
      return anyFormFieldsLoaded
    },
    environment() {
      const heading = (this.applicationHeading || "").toLowerCase();
      if (heading.includes(" dev")) {
        return "DEV";
      } else if (heading.includes(" test")) {
        return "TEST";
      } else if (heading.includes(" local")) {
        return "LOCAL";
      }
      return "";
    }
  },
  watch: {
  $route(to) {
    const tabMap = {
      '/toplist': 'Toplist',
      '/programs': 'Programs',
      '/campaigns': 'Campaigns',
      '/site': 'Site',
    };
    const activeTab = tabMap[to.path] || null;
    this.$store.commit(
      'systemInfo/updateActiveTab',
      activeTab,
    );
  },
},
  methods: {
    openInfoLink() {
      window.open('https://mms.se/wp-content/uploads/manual-online-analys.pdf', '_blank');
    }
  }
};
</script>

<style scoped>
.btn-xs {
  padding: 0.25rem 0.4rem;
  font-size: 0.875rem;
  line-height: 0.5;
  border-radius: 0.2rem;
}
.clientinfotv{
  flex: 0 0 auto;
  background: none;
  border: none;
  padding: 0;
  cursor: default;
}
.center{
  margin: 0 auto;
}
.right{
  flex: 0 0 auto;
}
a {
  text-transform: uppercase;
  margin: 5px 20px;
  position: relative;
  display: inline-block;
  color: #337ab7;
}
.router-link-exact-active {
  font-weight: bold;
}
.subnavbackground {
  background-color: white;
  border-bottom: #aaa 1px dotted;
  height: 39px;
  padding: 5px 1.5rem 5px 1.5rem;
  padding-left: 16px;
  text-align: center;
  display: flex;
}
</style>
